import { useEffect, useState, type RefObject } from 'react';
import * as API from '../../API';
import { useFilingCabinetContext } from '../../Contexts/Authenticated/FilingCabinetContext';
import RazorView from './RazorView';

export interface NonFilingCabinetRazorViewProps {
    dataUrl: string;
    razorViewRef?: RefObject<HTMLDivElement>;
};

const NonFilingCabinetRazorView = ({
    dataUrl,
    razorViewRef,

}: NonFilingCabinetRazorViewProps): React.ReactElement => {
    const [initialHTML, setInitialHTML] = useState<string>();
    const { setNoActive } = useFilingCabinetContext();

    useEffect(() => {
        void API.general.getRazorView(dataUrl)
            .then((serverHTML) => {
                setNoActive();
                setInitialHTML(serverHTML);
            });
    }, [dataUrl]);

    return <RazorView razorViewRef={razorViewRef} initialContentHTML={initialHTML} />;
};

export default NonFilingCabinetRazorView;
